import { render, staticRenderFns } from "./TransactionHistory.vue?vue&type=template&id=6c13328e&scoped=true"
import script from "./TransactionHistory.vue?vue&type=script&lang=js"
export * from "./TransactionHistory.vue?vue&type=script&lang=js"
import style0 from "./TransactionHistory.vue?vue&type=style&index=0&id=6c13328e&prod&lang=scss&scoped=true"
import style1 from "./TransactionHistory.vue?vue&type=style&index=1&id=6c13328e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c13328e",
  null
  
)

export default component.exports